// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.softlite-sizing-text-control>div{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.softlite-sizing-text-control>div label{
    margin-bottom: 0;
    text-transform: capitalize;
    font-size: 13px;
    font-weight: 400;
}
.softlite-sizing-text-control>div .components-text-control__input{
    width: 50%;
    text-align: center;
}
.softlite-sizing-text-control .components-flex{
    gap: 0;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.softlite-sizing-text-control .components-flex>div{
    width: 50%;
}

.softlite-color-indicator {
    transform: translateY(-2px);
}`, "",{"version":3,"sources":["webpack://./assets/js/src/controls/sizing/sizing.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,MAAM;IACN,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".softlite-sizing-text-control>div{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.softlite-sizing-text-control>div label{\r\n    margin-bottom: 0;\r\n    text-transform: capitalize;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n}\r\n.softlite-sizing-text-control>div .components-text-control__input{\r\n    width: 50%;\r\n    text-align: center;\r\n}\r\n.softlite-sizing-text-control .components-flex{\r\n    gap: 0;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.softlite-sizing-text-control .components-flex>div{\r\n    width: 50%;\r\n}\r\n\r\n.softlite-color-indicator {\r\n    transform: translateY(-2px);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
